const STORAGE_PREFIX = 'saloon_insights_prefs'

/**
 * @returns {{ period: string, compare: string, customFrom: string, customTo: string, favourites: string[], favouritesOnly: boolean, category: string, search: string, expiringWindowDays: number }}
 */
export function defaultInsightsPreferences() {
  return {
    period: 'month',
    compare: 'none',
    customFrom: '',
    customTo: '',
    favourites: [],
    favouritesOnly: false,
    category: 'all',
    search: '',
    expiringWindowDays: 30,
    activeReportKey: 'daily-sales',
  }
}

/**
 * @param {number | string | null | undefined} branchId
 */
export function loadInsightsPreferences(branchId) {
  if (!branchId) return defaultInsightsPreferences()

  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}_${branchId}`)
    if (!raw) return defaultInsightsPreferences()
    return { ...defaultInsightsPreferences(), ...JSON.parse(raw) }
  } catch {
    return defaultInsightsPreferences()
  }
}

/**
 * @param {number | string | null | undefined} branchId
 * @param {Record<string, unknown>} prefs
 */
export function saveInsightsPreferences(branchId, prefs) {
  if (!branchId) return
  try {
    localStorage.setItem(`${STORAGE_PREFIX}_${branchId}`, JSON.stringify(prefs))
  } catch {
    // Ignore quota errors.
  }
}

export const REPORT_CATEGORY_LABELS = {
  sales: 'Sales',
  financial: 'Financial',
  accounts: 'Accounts',
  operations: 'Operations',
  staff: 'Staff',
  packages: 'Packages',
  inventory: 'Inventory',
  crm: 'CRM',
}
